import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "registration" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "registration__input" }
const _hoisted_4 = { class: "registration__input" }
const _hoisted_5 = { class: "registration__input" }
const _hoisted_6 = { class: "registration__submit" }
const _hoisted_7 = { class: "registration__text" }
const _hoisted_8 = { class: "registration__tg" }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = { class: "registration__reg-text" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "login__input" }
const _hoisted_13 = { class: "login__submit" }
const _hoisted_14 = { class: "login__tg" }
const _hoisted_15 = { class: "login__hint" }

import { computed } from 'vue'
import { i18n } from '@/locales/i18n'
import { getAxiosErrorText } from '@/common/helpers'

// Store
import { useAuthModalStore, useCommonStore } from '@/store'

import Button from '@/components/ui/Button'
import Title from '@/components/ui/Title'
import InputText from '@/components/inputs/InputText'
import { ElNotification, ElCheckbox } from 'element-plus'

// Methods

export default /*#__PURE__*/_defineComponent({
  __name: 'Registration',
  setup(__props) {

const modalStore = useAuthModalStore()
const commonStore = useCommonStore()

// Components
function showError(e: any): void {
  ElNotification({
    title: i18n.t('common.error'),
    message: getAxiosErrorText(e),
    type: 'error',
  })
}


// Computed
const isFormValid = computed<boolean>(() =>
    Boolean(
        modalStore.registration?.login
        && modalStore.registration?.login?.length >= 2
        && modalStore.registration?.name
        && modalStore.registration?.name?.length >= 2
        && modalStore.registration?.agree,
    ),
)
const isCodeValid = computed<boolean>(() => Boolean(modalStore.registration?.code && modalStore.registration?.code?.length >= 4))

const regLink = computed<string>(() => `https://t.me/TopsellerMP_bot?start=${modalStore.registration?.login}`)

// Methods
async function tryToCheckRegister() {
  modalStore.registration.screen = 'code'
  // modalStore.loading = true
  // try {
  //   const data = {
  //     name: modalStore?.registration?.name,
  //     login: modalStore?.registration?.login,
  //   }
  //   await modalStore.createLogin(data)
  //   modalStore.registration.screen = 'code'
  // } catch (e) {
  //   showError(e)
  // } finally {
  //   modalStore.loading = false
  // }
}

async function tryToFinishRegister() {
  modalStore.loading = true
  try {
    const data = {
      welcome_name: modalStore?.registration?.name,
      username: modalStore?.registration?.login,
      code_confirm: Number(modalStore?.registration?.code),
    }
    const token = (await modalStore.createAccount(data)).data.token
    localStorage.setItem('token', token)
    const user = await commonStore.getUser()
    commonStore.user = user
    modalStore.$reset()
  } catch (e) {
    showError(e)
  } finally {
    modalStore.loading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Title), {
      class: "registration__title",
      theme: ['modal', 'centered']
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.title')), 1)
      ]),
      _: 1
    }),
    (_unref(modalStore).registration.screen === 'index')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(tryToCheckRegister, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(InputText), {
              name: "login",
              focus: "",
              modelValue: _unref(modalStore).registration.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(modalStore).registration.name) = $event)),
              label: _ctx.$t('registrationModal.name')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(InputText), {
              theme: "tg",
              name: "tg",
              modelValue: _unref(modalStore).registration.login,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(modalStore).registration.login) = $event)),
              label: _ctx.$t('registrationModal.login')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ElCheckbox), {
              modelValue: _unref(modalStore).registration.agree,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(modalStore).registration.agree) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.agree.text')) + " ", 1),
                _createVNode(_component_router_link, { to: {name: 'Main'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.agree.link')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              theme: ['stretched', 'huge'],
              disabled: !isFormValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.submit.first')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.hasAccount.text')) + " ", 1),
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(modalStore).openLogin()))
            }, _toDisplayString(_ctx.$t('registrationModal.hasAccount.link')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Button), {
              type: "a",
              theme: "tg",
              href: _ctx.$t('common.buttons.chat.link')
            }, {
              append: _withCtx(() => [
                _createVNode(_component_draw_svg, {
                  name: "tg",
                  width: "18",
                  height: "18"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.chat.title')) + " ", 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(modalStore).registration.screen === 'code')
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _withModifiers(tryToFinishRegister, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.text')) + " ", 1),
            _createElementVNode("a", {
              href: regLink.value,
              target: "_blank"
            }, "@" + _toDisplayString(_ctx.$t('common.bot.name')), 9, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(InputText), {
              name: "code",
              modelValue: _unref(modalStore).registration.code,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(modalStore).registration.code) = $event)),
              label: _ctx.$t('registrationModal.getCode')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Button), {
              theme: ['stretched', 'huge'],
              disabled: !isCodeValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('registrationModal.submit.second')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Button), {
              type: "a",
              theme: "tg",
              href: _ctx.$t('common.buttons.chat.link')
            }, {
              append: _withCtx(() => [
                _createVNode(_component_draw_svg, {
                  name: "tg",
                  width: "18",
                  height: "18"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.chat.title')) + " ", 1)
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('registrationModal.hint')), 1)
        ], 40, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}
}

})